/**
 * What an operator sees when a render error reaches the top-level Sentry
 * boundary — instead of the white page that used to be the only signal.
 * The boundary reports the event; this screen is purely for the human.
 *
 * `resetError` re-renders from the boundary down, which recovers from
 * transient state bugs; Reload is the honest fallback when it does not.
 */
export default function CrashScreen({ resetError }) {
    return (
        <div style={{ padding: '48px', textAlign: 'center' }}>
            <h2>Something broke on this page</h2>
            <p>The error has been reported automatically.</p>
            <button className="btn btn-primary" onClick={resetError}>Try again</button>{' '}
            <button className="btn btn-secondary" onClick={() => window.location.reload()}>Reload the page</button>
        </div>
    );
}
